<template>
  <NuxtLayout>
    <NuxtLoadingIndicator />
    <Templates404 />
  </NuxtLayout>
</template>
